/**
 * Helper function to toggle multiple multiple classes of an Element at once.
 *
 * @param {Element}   element    The Element to operate on
 * @param {...string} classNames A list of class names to toggle
 *
 * @return {void}
 */
export default (
	element: Element,
	...classNames: string[]
): void => {
	classNames.map(
		cl => element.classList.toggle( cl ),
	);
};
